// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"6ad729c2","116":"4a847370"}[chunkId] + ".chunk.css";
};